import titleAndDescription from './TitleAndDescription';
import mainCharts from './MainCharts';
import comments from './Comments';

export default [titleAndDescription, mainCharts, comments];
